import { useLocation, useRouteError } from "react-router-dom";
import { stringify_recursive } from "../../utils/utils";
import useConfig from "../../hooks/useConfig";

export default function ErrorPage() {

    let print = false

    const error = useRouteError()
    const { config: configSignal } = useConfig()
    const { location } = useLocation()

    if (print) {
        console.log(stringify_recursive(error, false))
        console.error(error)
    }
    let body = null
    const ssoUrl = configSignal.value == null ? "" : configSignal.value.ssoBaseUrl
    const localDebug = window.location.hostname === "localhost"
    if (Object.prototype.hasOwnProperty.call(error, 'code')) {
        if (print) {
            console.log("Error has a code")
        }
        switch (error.code.toString()) {
            case '401':
                if (print) {
                    console.log("Logged config", configSignal.value)
                    console.log('localDebug', localDebug)
                }
                if (!localDebug) {
                    // redirect to sso to sign on unless we are doing local development.
                    // for local development we will load a page with link to give opportunity to set the accessToken manually
                    window.location.href=`${ssoUrl}?clientid=4`
                }
                body = (
                    <>
                        <h1>Unauthorized</h1>
                        <p>
                            You are not logged in, or your session has expired.&nbsp;
                            <a href={ssoUrl.concat("/?clientid=4")}>Please click here to login.</a>
                        </p>
                    </>
                )
                break
            default:
                if (print) {
                    console.log("No special handling for error code ".concat(error.code).concat(" of type ").concat(typeof error.code))
                }
                break
        }
    }
    else if(print){
        console.log("Error does not have a code")
    }
    if(body == null){
        body = (
            <>
                <h1>Oops!</h1>
                <p>Sorry, an unexpected error has occurred.</p>
                <p>
                    <i>{error.statusText || error.message}</i>
                </p>
            </>
        )
    }

    return (
        <div id="error-page">{body}</div>
    );
}